// WebApp serveo URL
// http://localhost:8069
export function hiredrateBridgeURL() {
  // return "http://localhost:8069";
  return "https://api.gtm.hiredrate.com";

}

export const generateUUID = () => {
  // if (crypto?.randomUUID) {
  //   return crypto.randomUUID();
  // }
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};
